import { Outlet } from "react-router-dom";
import LoadingSpinner from "../../Loading/LoadingSpinner";
import Header from "../../components/Header";
import Toast from "../../Modals/toast/Toast";

export default function MainLayout({ children }) {
  return (
    <>
    <div className="w-screen">
      <Toast></Toast>
      <Header/>
      <LoadingSpinner></LoadingSpinner>
      <Outlet />
      {/* <Footer /> */}
      </div>
 
    </>
  );
}
